import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { EnvironmentsComponent } from './environments.component';
import { EnvironmentOverviewComponent } from './overview';
import { EditEnvironmentComponent } from './editEnvironment';

export const ENVIRONMENT_ROUTES: Routes = [
    {
        path: 'environments',
        component: EnvironmentsComponent,
        canActivate: [MsalGuard],
        children: [
            { path: '', redirectTo: 'overview', pathMatch: 'full' },
            { path: 'overview', component: EnvironmentOverviewComponent },
            { path: 'edit/:id', component: EditEnvironmentComponent }
        ]
    }
];